/* One paginated catalog; filters apply to every loaded batch without resetting selection. */
(() => {
 const home=document.querySelector('[data-side-b-home]');
 if(!home || home.dataset.sbReady) return;
 home.dataset.sbReady='true';
 const grid=home.querySelector('.sb-products'), sentinel=home.querySelector('[data-sb-pagination]');
 const fallback=sentinel.querySelector('a'), status=home.querySelector('[data-sb-status]');
 let category='all', next=sentinel.dataset.next, loading=false, failures=0, retryTimer;
 const ids=new Set([...grid.children].map(row=>row.dataset.sbId));
 function update(){
  let count=0;
  [...grid.children].forEach(row=>{
   row.hidden=!(category==='all'||(category==='new'?row.dataset.sbNew==='true':row.dataset.sbCategory===category));
   if(!row.hidden) count++;
  });
  home.querySelector('[data-sb-empty]').hidden=count!==0||Boolean(next)||loading;
  status.textContent=count+' products shown'+(loading?' — loading more':'');
  home.querySelectorAll('[data-sb-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sbFilter===category)));
 }
 function nearEnd(){return sentinel.getBoundingClientRect().top<window.innerHeight+600;}
 async function load(){
  if(loading||!next||failures>=3||!nearEnd())return;
  loading=true; grid.setAttribute('aria-busy','true');update();
  const requested=next;
  try{
   const url=new URL(requested,location.origin);url.searchParams.set('section_id',home.dataset.sectionId);
   const response=await fetch(url,{credentials:'same-origin'});
   if(!response.ok)throw new Error('Catalog request failed');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   const incoming=doc.querySelector('[data-side-b-home]');
   const page=incoming&&incoming.querySelector('[data-sb-pagination]');
   if(!page)throw new Error('Missing catalog pagination');
   const fragment=document.createDocumentFragment();
   incoming.querySelectorAll('.sb-products > [data-sb-id]').forEach(row=>{
    if(ids.has(row.dataset.sbId))return;
    ids.add(row.dataset.sbId);
    // Subsequent pages must not eagerly compete with visible product photos.
    row.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.setAttribute('fetchpriority','low');});
    fragment.append(row);
   });
   grid.append(fragment);next=page.dataset.next||'';
   if(next===requested)next='';
   sentinel.dataset.next=next;failures=0;
   if(fallback){fallback.href=next||'#';fallback.hidden=true;}
  }catch(error){
   failures++;
   if(failures<3)retryTimer=setTimeout(load,1000*failures);
   else if(fallback){fallback.hidden=false;fallback.href=requested;status.textContent='Unable to load more. Continue to the next page.';}
  }finally{
   loading=false;grid.removeAttribute('aria-busy');update();
   if(!failures&&next)requestAnimationFrame(load);
  }
 }
 home.querySelectorAll('[data-sb-filter]').forEach(control=>control.addEventListener('click',()=>{
  category=control.dataset.sbFilter;update();requestAnimationFrame(load);
 }));
 if(fallback)fallback.hidden=true;
 const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'600px'});
 observer.observe(sentinel);
 // Re-check after a short/filtered batch even if the sentinel never left the viewport.
 update();requestAnimationFrame(load);
 window.addEventListener('pagehide',()=>{observer.disconnect();clearTimeout(retryTimer);},{once:true});
})();
